export default __webpack_public_path__ + "static/media/293.2243df3a.png";